import { color, Common, device } from '@stockbit/ui';
import { Skeleton } from 'antd';
import styled from 'styled-components';

const { Flex, IconMoreOptions, Text } = Common;

const CardHeader = styled(Flex).attrs({ padding: '9px 12px', align: 'center' })`
  position: relative;
  border-bottom: 1px solid ${color.downgray};
  padding: 20px 16px;
`;

const Wrapper = styled.div`
  display: none;
  background-color: ${color.light};
  border: solid 1px ${color.downgray};
  border-radius: 4px;
  margin-bottom: 20px;
  margin-right: 30px;
  position: relative;
  min-width: 320px;

  @media ${device.tablet} {
    display: flex;
    flex-direction: column;
  }
`;

const TableHeaderTextSkeleton = styled(Skeleton)`
  margin-left: 15px;

  & .ant-skeleton-content {
    & > .ant-skeleton-title {
      margin: 0 0 7.5px;
    }

    & > .ant-skeleton-paragraph {
      margin: 0;
    }
  }
`;

const SubCompanyText = styled(Text)`
  max-width: 225px;
`;

export {
  CardHeader,
  IconMoreOptions,
  Wrapper,
  TableHeaderTextSkeleton,
  SubCompanyText,
};
